import { render } from "./ReviewTaskPage.vue?vue&type=template&id=45532c34&ts=true"
import script from "./ReviewTaskPage.ts?vue&type=script&lang=ts&external"
export * from "./ReviewTaskPage.ts?vue&type=script&lang=ts&external"

import "./ReviewTaskPage.vue?vue&type=style&index=0&id=45532c34&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__